/**
 * Tillbehör "Komplettera med fat":
 * - PDP: valrutor + förstorat fat + ATC-summa (glasruta borttagen från galleriet)
 * - Collection-kort: piller E4 · Svävar; tryck lägger till / tar bort fatet
 */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 62em)');

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function formatPrice(cents) {
    if (window.TamburFormatMoney) return window.TamburFormatMoney(cents);
    return Math.round(cents / 100) + ' kr';
  }

  function wantsFatFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('med-fat') === '1';
    } catch (e) {
      return false;
    }
  }

  function initProduct(scope) {
    var hero = qs(scope, '[data-tillbehor-fat]');
    if (!hero || hero.getAttribute('data-fat-bound') === 'true') return;
    hero.setAttribute('data-fat-bound', 'true');

    var root = hero.closest('.tambur-product') || document;
    var config = {};
    try {
      config = JSON.parse(qs(hero, '[data-tillbehor-fat-config]').textContent);
    } catch (e) { /* ignore */ }
    var t = config.i18n || {};
    var fatId = hero.getAttribute('data-fat-variant-id');
    var fatPrice = Number(config.fatPrice) || 0;
    var available = hero.getAttribute('data-fat-available') === 'true';

    var form = qs(root, 'form.tambur-product__form');
    var atc = qs(root, '[data-add-to-cart]');
    var atcLabel = qs(atc, '[data-atc-label]');
    var atcPrice = qs(atc, '[data-atc-price]');
    var toggle = qs(hero, '[data-fat-toggle]');
    var kick = qs(hero, '[data-fat-kick]');
    var shortLabel = qs(hero, '[data-fat-short]');
    var zoom = qs(hero, '[data-fat-zoom]');
    var zoomOpen = qs(root, '[data-fat-zoom-open]');
    var zoomClose = qs(hero, '[data-fat-zoom-close]');
    var zoomToggle = qs(hero, '[data-fat-zoom-toggle]');
    var zoomLabel = qs(hero, '[data-fat-zoom-label]');
    var picks = qsa(root, '[data-fat-pick]');
    var cupPriceEl = qs(root, '[data-fat-tile-cup-price]');
    var setPriceEl = qs(root, '[data-fat-tile-set-price]');
    var setPick = qs(root, '[data-fat-pick="set"]');

    var addon = null;
    if (form && fatId && available) {
      addon = document.createElement('input');
      addon.type = 'hidden';
      addon.value = fatId;
      addon.disabled = true;
      addon.setAttribute('data-cart-addon-id', '');
      form.appendChild(addon);
    }

    root.classList.add('has-tillbehor-fat');
    var added = false;

    function cupPrice() {
      var idInput = form && form.querySelector('input[name="id"]');
      var prices = config.cupPrices || {};
      var id = idInput ? idInput.value : '';
      if (prices[id] != null) return Number(prices[id]);
      var keys = Object.keys(prices);
      return keys.length ? Number(prices[keys[0]]) : 0;
    }

    function render() {
      var on = added && available;
      hero.classList.toggle('is-added', on);
      root.classList.toggle('is-fat-added', on);
      if (addon) addon.disabled = !on;

      if (toggle) {
        toggle.setAttribute('aria-pressed', String(on));
        toggle.setAttribute('aria-label', on ? t.remove : t.add);
      }
      if (kick) kick.textContent = on ? t.kickerAdded : t.kicker;
      if (shortLabel) shortLabel.textContent = on ? t.shortAdded : t.short;
      if (zoomLabel && available) zoomLabel.textContent = on ? t.zoomAdded : t.zoomAdd;
      if (zoomToggle) zoomToggle.setAttribute('aria-pressed', String(on));

      picks.forEach(function (b) {
        b.setAttribute('aria-pressed', String((b.getAttribute('data-fat-pick') === 'set') === on));
      });

      var cup = cupPrice();
      if (cupPriceEl) cupPriceEl.textContent = formatPrice(cup);
      if (setPriceEl) setPriceEl.textContent = formatPrice(cup + fatPrice);
      if (atcLabel) atcLabel.textContent = on ? (DESKTOP.matches ? t.atcSet : t.atcSetShort) : t.atc;
      if (atcPrice) atcPrice.textContent = formatPrice(on ? cup + fatPrice : cup);
    }

    function set(on) {
      added = !!on;
      render();
    }

    if (toggle) toggle.addEventListener('click', function () { set(!added); });
    if (zoomToggle) zoomToggle.addEventListener('click', function () { set(!added); });
    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        var wantSet = b.getAttribute('data-fat-pick') === 'set';
        /* Andra klicket på redan vald "Kopp + fat" öppnar förstoringen. */
        if (wantSet && added && available) {
          openZoom();
          return;
        }
        set(wantSet);
      });
    });

    /* Varianten kan byta koppens pris; produktsidans egen updatePrice skriver först. */
    if (form) {
      form.addEventListener('change', function () { setTimeout(render, 0); });
    }
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', render);

    function openZoom() {
      if (!zoom) return;
      zoom.hidden = false;
      if (setPick) setPick.setAttribute('aria-expanded', 'true');
      if (zoomOpen) zoomOpen.setAttribute('aria-expanded', 'true');
      if (zoomClose) zoomClose.focus({ preventScroll: true });
    }

    function closeZoom() {
      if (!zoom || zoom.hidden) return;
      zoom.hidden = true;
      if (zoomClose) zoomClose.classList.remove('is-spinning');
      if (setPick) setPick.setAttribute('aria-expanded', 'false');
      if (zoomOpen) {
        zoomOpen.setAttribute('aria-expanded', 'false');
        zoomOpen.focus({ preventScroll: true });
      } else if (setPick) {
        setPick.focus({ preventScroll: true });
      }
    }

    if (zoomOpen) zoomOpen.addEventListener('click', openZoom);

    if (zoomClose) {
      zoomClose.addEventListener('click', function (e) {
        e.preventDefault();
        if (zoomClose.classList.contains('is-spinning')) return;
        var icon = zoomClose.querySelector('svg');
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          clearTimeout(fallback);
          closeZoom();
        }
        var fallback = setTimeout(finish, 450);
        zoomClose.classList.add('is-spinning');
        if (icon) icon.addEventListener('animationend', finish, { once: true });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoom && !zoom.hidden) closeZoom();
    });

    if (available && wantsFatFromUrl()) set(true);
    else render();
  }

  function openCartDrawer() {
    var trigger = document.querySelector('[data-cart-drawer-open]');
    if (trigger) trigger.click();
  }

  function updateCartBadges(count) {
    qsa(document, '[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.hidden = false;
        el.removeAttribute('hidden');
      } else {
        el.hidden = true;
        el.setAttribute('hidden', '');
      }
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function findFatLine(cart, fatId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].id) === fatId || Number(items[i].variant_id) === fatId) {
        return items[i];
      }
    }
    return null;
  }

  function setCardAdded(card, on) {
    var added = !!on;
    card.classList.toggle('is-added', added);
    card.setAttribute('aria-pressed', String(added));
    card.setAttribute(
      'aria-label',
      added ? (card.getAttribute('data-label-remove') || '') : (card.getAttribute('data-label-add') || '')
    );
    var line1 = qs(card, '[data-fat-card-line1]');
    var line2 = qs(card, '[data-fat-card-line2]');
    if (line1) {
      line1.textContent = added
        ? (card.getAttribute('data-label-added-1') || '')
        : (card.getAttribute('data-label-idle-1') || '');
    }
    if (line2) {
      line2.textContent = added
        ? (card.getAttribute('data-label-added-2') || '')
        : (card.getAttribute('data-label-idle-2') || '');
    }
  }

  function addFat(fatId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: fatId, quantity: 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function removeFat(fatId) {
    return fetchCart().then(function (cart) {
      var line = findFatLine(cart, fatId);
      if (!line) return cart;
      var nextQty = Math.max(0, (line.quantity || 1) - 1);
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: nextQty })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      });
    });
  }

  function bindCardHover(card) {
    var host = card.closest('.tambur-product-card');
    if (!host || host.getAttribute('data-fat-hover-bound') === 'true') return;
    host.setAttribute('data-fat-hover-bound', 'true');
    host.addEventListener('pointerenter', function () {
      host.classList.add('is-fat-pill-hover');
    });
    host.addEventListener('pointerleave', function () {
      host.classList.remove('is-fat-pill-hover');
    });
  }

  function initCard(card) {
    if (!card || card.getAttribute('data-fat-card-bound') === 'true') return;
    card.setAttribute('data-fat-card-bound', 'true');

    var fatId = parseInt(card.getAttribute('data-fat-variant-id'), 10);
    var available = card.getAttribute('data-fat-available') === 'true';
    if (!fatId || !available) return;

    bindCardHover(card);

    var busy = false;

    fetchCart().then(function (cart) {
      if (findFatLine(cart, fatId)) setCardAdded(card, true);
    }).catch(function () { /* ignore */ });

    card.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (busy || card.disabled) return;
      busy = true;
      card.disabled = true;

      var removing = card.classList.contains('is-added');
      var action = removing ? removeFat(fatId) : addFat(fatId);

      action
        .then(function (data) {
          setCardAdded(card, !removing);
          if (!removing) {
            (data && Array.isArray(data.items) ? data.items : [data]).forEach(function (item) {
              if (item && item.id) {
                document.dispatchEvent(new CustomEvent('tambur:tracking:add-to-cart', { detail: item }));
              }
            });
            openCartDrawer();
          } else if (data && typeof data.item_count === 'number') {
            updateCartBadges(data.item_count);
            var drawer = document.querySelector('[data-cart-drawer]');
            if (drawer && drawer.classList.contains('is-open')) openCartDrawer();
          }
        })
        .catch(function (err) {
          var msg = (err && err.description) ? err.description : 'Kunde inte uppdatera korgen.';
          alert(msg);
        })
        .finally(function () {
          busy = false;
          card.disabled = false;
        });
    });
  }

  function boot(scope) {
    var root = scope || document;
    initProduct(root);
    qsa(root, '[data-tillbehor-fat-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  /* Oändlig scroll / AJAX-filter byter grid-HTML. */
  document.addEventListener('tambur:collection:grid-updated', function (e) {
    boot((e && e.target) || document);
  });
})();
